/* AUTO-GENERATED from swagger.json. DO NOT EDIT BY HAND. */

import { HttpInterceptorRouteConfig } from '@auth0/auth0-angular';

export type AllowedHttpMethod = 'GET'|'POST'|'PUT'|'PATCH'|'DELETE'|'OPTIONS'|'HEAD';

type ExactMap = Partial<Record<AllowedHttpMethod, ReadonlyArray<string>>>;
type RegexMap = Partial<Record<AllowedHttpMethod, ReadonlyArray<RegExp>>>;

function stripBase(apiBaseUrl: string, uri: string): string | null {
  const base = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl;

  // Only match our API base
  if (!uri.startsWith(base)) return null;

  // Remove the base. Ensure leading "/" for comparison with OpenAPI paths.
  const rest = uri.substring(base.length);
  if (rest === '') return '/';
  return rest.startsWith('/') ? rest : '/' + rest;
}

const ANON_EXACT: ExactMap = {
  'DELETE': [],
  'GET': ["/","/accela-cap-record-documents","/accela-cap-records","/announcements","/banked-development-rights","/bmp-registrations","/bmp-registrations/maximum-duration","/clarity-documents","/climate-resilience-goals","/climate-resilience-indicators","/climate-resilience-outcomes","/commodities","/commodity-pools/pool-balance-report","/credit-declarations","/credit-declarations/secured-credits","/credit-distributions","/credit-distributions/secured-credits","/credit-targets","/credit-targets/water-years","/cumulative-accounting/dashboard/latest","/deed-restrictions","/eip-action-priorities","/eip-focus-areas","/eip-focus-areas/taxonomy","/eip-performance-measures","/eip-performance-measures/lookup","/eip-programs","/eip-projects/completed","/eip-projects/featured","/eip-projects/featured-candidates","/eip-projects/featured-grid","/eip-projects/five-year-list","/eip-projects/mapped-point/feature-collection","/eip-projects/regional/feature-collection","/field-definitions","/field-definitions/labels","/funding-sources","/health","/home/data-center-stats","/indicators","/indicators/eip-programs-lookup","/indicators/monitoring-programs-lookup","/indicators/related-entities-lookup","/indicators/relationship-types-lookup","/indicators/threshold-evaluation-periods-lookup","/indicators/threshold-indicators-lookup","/indicators/threshold-related-entity-types-lookup","/indicators/threshold-reporting-categories-lookup","/indicators/threshold-standard-types-lookup","/jurisdictions/feature-collection","/land-capability-types","/local-and-regional-plans","/local-and-regional-plans/lookup","/modeled-catchments","/monitoring-programs","/monitoring-programs/featured","/monitoring-programs/transit","/monitoring-programs/transit/annual-ridership/download","/monitoring-programs/transit/default-fiscal-year","/mooring-document-types","/mooring-lottery-submissions","/mooring-registration-submissions/find-by-reference-number","/mooring-tags/find","/mooring-types","/moorings","/moorings/home","/nrap-findings","/nrap-findings/focus-areas-dropdown","/nrap-findings/projects-dropdown","/nrap-focus-areas","/nrap-focus-areas/monitoring-programs-dropdown","/organizations","/organizations/approved","/organizations/approved-active","/organizations/lookup","/organizations/validate-abbreviation","/organizations/validate-name","/parcel-bmp-assessments","/parcel-tracker-search","/parcels/land-banks","/parcels/search","/program-info/credit-calculation-parameters","/project-funding-organizations","/project-funding-source-expenditures","/project-images","/project-implementing-organizations","/project-tags","/projects","/projects/location-info-at-point","/projects/project-location-areas","/projects/search","/release-notes","/results/eip-home-accomplishments","/results/investment-by-funding-sector","/results/investment-by-funding-sector/project-count","/results/spending-by-funding-sector-by-program","/road-assessment-observation-periods","/road-classes","/road-registration-credit-declarations","/road-registration-credit-declarations/secured-credits","/road-registrations","/road-registrations/maximum-duration","/road-segment-assessments","/road-segments","/sectors","/shorezone-allocations/report","/state-provinces","/stormwater-jurisdictions","/stormwater-jurisdictions/lookup-items","/stormwater-jurisdictions/my-jurisdictions/lookup-items","/stormwater-projects","/support-request-types","/tags","/tags/lookup","/tdr-listings/listing-types","/tdr-listings/published","/tdr-transactions","/threshold-categories","/threshold-compliance-measures","/threshold-compliance-measures/latest","/threshold-evaluation-summary/dashboard/latest","/threshold-evaluations/periods","/threshold-indicator-updates/related-entity-types-lookup","/threshold-indicators","/threshold-indicators/search","/threshold-indicators/tree","/threshold-reporting-categories","/transportation-data-trends","/transportation-goals","/transportation-goals/simple","/transportation-goals/taxonomy","/transportation-objectives","/transportation-objectives/grid","/transportation-projects","/transportation-projects/featured","/transportation-projects/regional/map-markers","/transportation-questions","/transportation-strategies","/transportation-strategies/grid","/transportation-strategies/taxonomy","/transportation-sub-goals","/transportation-sub-goals/simple","/transportation/funding-dashboard/chart-data","/transportation/home/map-data","/treatment-bmp-observation-types","/treatment-bmp-observation-types/lookups/collection-methods","/treatment-bmp-observation-types/lookups/measurement-unit-types","/treatment-bmp-observation-types/lookups/specifications","/treatment-bmp-observation-types/lookups/target-types","/treatment-bmp-observation-types/lookups/threshold-types","/treatment-bmp-types","/treatment-bmp-types/assessment-types","/treatment-bmp-types/index","/treatment-bmp-types/lookups/observation-types","/treatment-bmp-types/obsolete","/treatment-bmp-version-assessments","/treatment-bmps","/treatment-bmps/verified/feature-collection","/watersheds","/watersheds/at-point","/watersheds/lookup"],
  'POST': ["/request-support","/transportation/funding-dashboard/chart-data"],
  'PUT': [],
};

const SECURED_EXACT: ExactMap = {
  'DELETE': [],
  'GET': ["/bmp-compliance-reports","/bmp-compliance-reports/new-template","/bmp-compliance-reports/public","/bmp-compliance-reports/published-exists","/bmp-registrations/assessable","/climate-resilience-goals/grid-rows","/climate-resilience-outcomes/grid-rows","/commodity-pools","/commodity-pools/lookup-commodities","/commodity-pools/lookup-jurisdictions","/corral-pages","/deed-restricted-parcels","/deed-restrictions/boilerplate-notes","/document-library","/field-definitions/grid","/indicators/threshold-manage/grid","/indicators/threshold-manage/page-info","/ipes-scores","/ipes-scores/all","/ipes-scores/excel-download","/ipes-scores/lookups","/launch-pad/action-items","/launch-pad/map-data","/lead-agencies","/lead-agencies/responsibility-matrix","/local-and-regional-plans/unmatched-plans","/ltInfoRoles","/monitoring-programs/transit/operators","/monitoring-users","/monitoring-users/roles","/mooring-fees/lottery-submission","/mooring-fees/permit-application","/mooring-fees/registration","/mooring-fees/registration/next-fee-year","/mooring-financial-reports/receipt-report","/mooring-financial-reports/springbrook-excel","/mooring-invoice-audits","/mooring-invoices","/mooring-invoices/line-items","/mooring-invoices/my","/mooring-invoices/paid-line-items","/mooring-invoices/unpaid-renewals","/mooring-lottery-submission-periods","/mooring-lottery-submissions/my","/mooring-lottery-submissions/my/years","/mooring-notifications","/mooring-prior-permit-payments","/mooring-prior-permits","/mooring-receipts","/mooring-registration-renewals/people-receiving-reminders","/mooring-registration-renewals/reminder-messages","/mooring-registration-submissions","/mooring-registration-submissions/contact-info-excel","/mooring-registration-submissions/people","/mooring-registration-submissions/potential-reviewers","/mooring-tags","/mooring-tags/registrations-requiring-tag-action","/moorings/new/edit-data","/organizations/user-account","/parcel-permits","/parcelTrackerRoles","/parcels-by-land-capability","/parcels/all","/parcels/boilerplate-notes/parcel-overview","/parcels/manage","/parcels/reports/inactive","/parcels/reports/inactive-transactions","/parcels/results/development-rights-inventory","/parcels/tracked","/projects/all-projects-for-update","/projects/download-full-database","/projects/my-organizations-projects","/projects/my-organizations-proposals","/projects/my-projects-requiring-update","/projects/people-receiving-reminders","/projects/planning-design-with-accomplishments","/projects/proposals","/projects/reminder-messages","/projects/send-reminder-emails/summary","/residential-allocations","/residential-allocations/roll-over/eligibility","/residential-allocations/summary","/road-segments/manageable","/roles/grid","/shorezone-allocations","/state-lands-permits","/state-lands-permits/can-manage","/stormwater-users","/support-request-logs","/tdr-listings","/tdr-transactions/chooser-options","/tdr-transactions/full-details-excel-download","/tdr-transactions/new-allocation","/tdr-transactions/new-allocation-assignment","/tdr-transactions/new-conversion","/tdr-transactions/new-conversion-with-transfer","/tdr-transactions/new-ecm-retirement","/tdr-transactions/new-land-bank-acquisition","/tdr-transactions/new-land-bank-transfer","/tdr-transactions/new-shorezone-allocation","/tdr-transactions/new-transfer","/transportation-assessments/export","/transportation-assessments/manage-data","/transportation-assessments/summary","/transportation-cost-parameters","/treatment-bmp-types/grid","/treatment-bmp-types/grid-obsolete","/treatment-bmps/assessable","/tsys/tsep-script","/users","/users/active","/users/primary-contacts"],
  'POST': ["/announcements","/bmp-compliance-reports","/bmp-registrations","/clarity-documents","/climate-resilience-goals","/climate-resilience-indicators","/climate-resilience-outcomes","/commodity-pools","/credit-declarations","/credit-declarations/draft","/credit-distributions","/credit-targets","/deed-restrictions","/document-library","/eip-action-priorities","/eip-focus-areas","/eip-performance-measures","/eip-programs","/funding-sources","/impersonation/stop","/indicators","/indicators/threshold-manage/bulk-upload-map-and-chart-urls","/ipes-scores","/local-and-regional-plans","/local-and-regional-plans/refresh-external-data","/modeled-catchments","/modeled-catchments/upload-gdb","/modeled-catchments/upload-gdb/approve","/modeled-catchments/upload-gdb/report","/monitoring-programs","/monitoring-sites","/mooring-fees/lottery-submission","/mooring-lottery-submission-periods","/mooring-lottery-submission-periods/current/finalize-remaining-allocations","/mooring-lottery-submissions/workflow/applicant-information","/mooring-prior-permits","/mooring-registration-renewals/send-custom-notification","/mooring-registration-renewals/send-preview-notification","/mooring-registration-renewals/send-reminders","/mooring-registration-submissions","/mooring-tags/bulk-mark-as-sent","/moorings","/nrap-findings","/nrap-focus-areas","/organizations","/parcel-bmp-assessments","/parcel-permits","/project-funding-organizations","/project-funding-source-expenditures","/project-images","/project-implementing-organizations","/project-tags","/projects/admin-create","/projects/create-workflow/steps/project-type","/projects/send-custom-notification","/projects/send-preview-notification","/projects/send-reminder-emails","/release-notes","/residential-allocations/roll-over","/road-assessment-observation-periods","/road-classes","/road-registration-credit-declarations","/road-registration-credit-declarations/draft","/road-registrations","/road-segment-assessments","/road-segments","/shorezone-allocations/bulk-upload","/sitkacapture/generate-pdf","/state-lands-permits/refresh-external-data","/stormwater-jurisdictions","/support-request-logs","/tags","/tags/bulk-tag-projects","/tdr-listings","/tdr-transactions/allocation","/tdr-transactions/allocation-assignment","/tdr-transactions/conversion","/tdr-transactions/conversion-with-transfer","/tdr-transactions/ecm-retirement","/tdr-transactions/land-bank-acquisition","/tdr-transactions/land-bank-transfer","/tdr-transactions/shorezone-allocation","/tdr-transactions/transfer","/threshold-categories","/threshold-reporting-categories","/transportation-cost-parameters","/transportation-data-trends","/transportation-goals","/transportation-objectives","/transportation-questions","/transportation-strategies","/transportation-sub-goals","/treatment-bmp-observation-types","/treatment-bmp-types","/treatment-bmp-version-assessments","/treatment-bmps","/user-claims","/users"],
  'PUT': ["/credit-targets/bulk","/eip-projects/featured","/eip-projects/focus-area-featured","/mooring-registration-renewals/reminder-messages","/projects/reminder-messages"],
};

const ANON_REGEX: RegexMap = {
  'DELETE': [

  ],
  'GET': [
    new RegExp("^/accela-cap-record-documents/[^/]+/download$"),
    new RegExp("^/accela-cap-records/[^/]+$"),
    new RegExp("^/announcements/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+/archives$"),
    new RegExp("^/bmp-registrations/[^/]+/credit-declarations$"),
    new RegExp("^/bmp-registrations/[^/]+/history$"),
    new RegExp("^/bmp-registrations/[^/]+/modeled-catchments$"),
    new RegExp("^/bmp-registrations/[^/]+/modeled-catchments-feature-collection$"),
    new RegExp("^/bmp-registrations/[^/]+/notifications$"),
    new RegExp("^/bmp-registrations/[^/]+/other-strategies$"),
    new RegExp("^/bmp-registrations/[^/]+/parcels-in-area$"),
    new RegExp("^/bmp-registrations/[^/]+/plrm-summary-report$"),
    new RegExp("^/bmp-registrations/[^/]+/review-comments$"),
    new RegExp("^/bmp-registrations/[^/]+/supporting-documents$"),
    new RegExp("^/bmp-registrations/[^/]+/treatment-bmps$"),
    new RegExp("^/bmp-registrations/[^/]+/treatment-bmps/feature-collection$"),
    new RegExp("^/bmp-registrations/[^/]+/update-rationales$"),
    new RegExp("^/bmp-registrations/[^/]+/withdraw-rationale$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/can-submit$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/progress$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/other-strategies$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/parcel-bmps$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/plrm-upload$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/register-bmps$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/register-credits$"),
    new RegExp("^/clarity-documents/[^/]+$"),
    new RegExp("^/climate-resilience-goals/[^/]+$"),
    new RegExp("^/climate-resilience-indicators/[^/]+$"),
    new RegExp("^/climate-resilience-outcomes/[^/]+$"),
    new RegExp("^/climate-resilience-outcomes/slug/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+/bmp-conditions$"),
    new RegExp("^/credit-declarations/[^/]+/review-comments$"),
    new RegExp("^/credit-distributions/[^/]+$"),
    new RegExp("^/credit-targets/[^/]+$"),
    new RegExp("^/credit-targets/by-jurisdiction/[^/]+$"),
    new RegExp("^/cumulative-accounting/dashboard/by-period/[^/]+$"),
    new RegExp("^/cumulative-accounting/dashboard/by-year/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/[^/]+/can-delete$"),
    new RegExp("^/cumulative-accounting/sections/by-period/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/headers/by-period/[^/]+$"),
    new RegExp("^/custom-rich-texts/[^/]+$"),
    new RegExp("^/eip-action-priorities/[^/]+$"),
    new RegExp("^/eip-action-priorities/[^/]+/mapped-point/feature-collection$"),
    new RegExp("^/eip-action-priorities/[^/]+/projects$"),
    new RegExp("^/eip-action-priorities/[^/]+/regional/feature-collection$"),
    new RegExp("^/eip-focus-areas/[^/]+$"),
    new RegExp("^/eip-focus-areas/[^/]+/action-priorities$"),
    new RegExp("^/eip-focus-areas/[^/]+/featured-projects$"),
    new RegExp("^/eip-focus-areas/[^/]+/projects$"),
    new RegExp("^/eip-performance-measures/[^/]+$"),
    new RegExp("^/eip-programs/[^/]+$"),
    new RegExp("^/eip-programs/[^/]+/plans$"),
    new RegExp("^/eip-programs/[^/]+/projects$"),
    new RegExp("^/eip-projects/[^/]+$"),
    new RegExp("^/eip-projects/by-number/[^/]+$"),
    new RegExp("^/eip-projects/fact-sheet-pdf/by-number/[^/]+$"),
    new RegExp("^/field-definitions/[^/]+$"),
    new RegExp("^/file-resources/[^/]+$"),
    new RegExp("^/file-resources/[^/]+/resized$"),
    new RegExp("^/funding-sources/[^/]+$"),
    new RegExp("^/funding-sources/[^/]+/expenditure-chart$"),
    new RegExp("^/funding-sources/[^/]+/project-expenditures$"),
    new RegExp("^/funding-sources/[^/]+/project-funding-requests$"),
    new RegExp("^/indicators/[^/]+$"),
    new RegExp("^/indicators/[^/]+/chart-data$"),
    new RegExp("^/indicators/[^/]+/chart-data/eip-program/[^/]+$"),
    new RegExp("^/indicators/[^/]+/expected-project-accomplishments$"),
    new RegExp("^/indicators/[^/]+/reported-project-accomplishments$"),
    new RegExp("^/indicators/[^/]+/subcategories$"),
    new RegExp("^/indicators/[^/]+/threshold-data$"),
    new RegExp("^/ipes-scores/[^/]+$"),
    new RegExp("^/land-capability-types/[^/]+$"),
    new RegExp("^/local-and-regional-plans/[^/]+$"),
    new RegExp("^/local-and-regional-plans/[^/]+/geometry-as-feature-collection$"),
    new RegExp("^/local-and-regional-plans/[^/]+/projects$"),
    new RegExp("^/local-and-regional-plans/[^/]+/projects-as-feature-collection$"),
    new RegExp("^/local-and-regional-plans/[^/]+/transportation-projects$"),
    new RegExp("^/modeled-catchments/[^/]+$"),
    new RegExp("^/modeled-catchments/[^/]+/bmp-registrations$"),
    new RegExp("^/modeled-catchments/[^/]+/road-registrations$"),
    new RegExp("^/monitoring-programs/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/dashboard$"),
    new RegExp("^/monitoring-programs/[^/]+/documents$"),
    new RegExp("^/monitoring-programs/[^/]+/images$"),
    new RegExp("^/monitoring-programs/[^/]+/indicators$"),
    new RegExp("^/monitoring-programs/[^/]+/observable-relationships$"),
    new RegExp("^/monitoring-programs/[^/]+/partners$"),
    new RegExp("^/monitoring-programs/[^/]+/site-attributes$"),
    new RegExp("^/monitoring-programs/[^/]+/sites$"),
    new RegExp("^/monitoring-programs/[^/]+/sites-as-feature-collection$"),
    new RegExp("^/monitoring-programs/by-vanity-url/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+/as-feature-collection$"),
    new RegExp("^/monitoring-sites/[^/]+/charts$"),
    new RegExp("^/monitoring-sites/[^/]+/collisions$"),
    new RegExp("^/monitoring-sites/[^/]+/collisions-as-feature-collection$"),
    new RegExp("^/monitoring-sites/[^/]+/images$"),
    new RegExp("^/monitoring-sites/[^/]+/rswmp-stations$"),
    new RegExp("^/monitoring-sites/[^/]+/stations$"),
    new RegExp("^/monitoring-sites/[^/]+/stations/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+/summary-stats$"),
    new RegExp("^/monitoring-sites/[^/]+/travel-times$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/detail$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/pay-fees-card$"),
    new RegExp("^/mooring-tags/[^/]+$"),
    new RegExp("^/moorings/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+/documents$"),
    new RegExp("^/nrap-focus-areas/[^/]+$"),
    new RegExp("^/organizations/[^/]+$"),
    new RegExp("^/organizations/[^/]+/accomplishments$"),
    new RegExp("^/organizations/[^/]+/commodity-pools$"),
    new RegExp("^/organizations/[^/]+/detailed-map-data$"),
    new RegExp("^/organizations/[^/]+/expenditure-chart-data$"),
    new RegExp("^/organizations/[^/]+/funding-sources$"),
    new RegExp("^/organizations/[^/]+/is-lead-agency$"),
    new RegExp("^/organizations/[^/]+/jurisdiction-boundary$"),
    new RegExp("^/organizations/[^/]+/land-bank$"),
    new RegExp("^/organizations/[^/]+/land-bank/map-data$"),
    new RegExp("^/organizations/[^/]+/manages-right-of-way-coverage$"),
    new RegExp("^/organizations/[^/]+/map-data$"),
    new RegExp("^/organizations/[^/]+/monitoring-programs$"),
    new RegExp("^/organizations/[^/]+/projects$"),
    new RegExp("^/organizations/[^/]+/right-of-way-coverage-summary$"),
    new RegExp("^/organizations/[^/]+/right-of-way-coverages$"),
    new RegExp("^/organizations/[^/]+/tdr-transactions$"),
    new RegExp("^/parcel-bmp-assessments/[^/]+$"),
    new RegExp("^/parcel-bmp-assessments/[^/]+/parcels-feature-collection$"),
    new RegExp("^/parcel-bmp-assessments/[^/]+/parcels-grid$"),
    new RegExp("^/parcels/[^/]+$"),
    new RegExp("^/parcels/[^/]+/bmp-compliance-status$"),
    new RegExp("^/parcels/[^/]+/geometry$"),
    new RegExp("^/parcels/[^/]+/images$"),
    new RegExp("^/parcels/[^/]+/land-capability-types$"),
    new RegExp("^/parcels/[^/]+/map-summary$"),
    new RegExp("^/parcels/[^/]+/notes$"),
    new RegExp("^/parcels/[^/]+/pay-fees-cards$"),
    new RegExp("^/project-funding-organizations/[^/]+$"),
    new RegExp("^/project-funding-source-expenditures/[^/]+$"),
    new RegExp("^/project-images/[^/]+$"),
    new RegExp("^/project-implementing-organizations/[^/]+$"),
    new RegExp("^/project-tags/[^/]+$"),
    new RegExp("^/projects/[^/]+$"),
    new RegExp("^/projects/[^/]+/basics$"),
    new RegExp("^/projects/[^/]+/bounding-box$"),
    new RegExp("^/projects/[^/]+/detailed-location$"),
    new RegExp("^/projects/[^/]+/eip-basics$"),
    new RegExp("^/projects/[^/]+/expected-funding$"),
    new RegExp("^/projects/[^/]+/expenditures$"),
    new RegExp("^/projects/[^/]+/expenditures-detail$"),
    new RegExp("^/projects/[^/]+/external-links$"),
    new RegExp("^/projects/[^/]+/images$"),
    new RegExp("^/projects/[^/]+/indicator-expected-values$"),
    new RegExp("^/projects/[^/]+/indicator-expected-values-detail$"),
    new RegExp("^/projects/[^/]+/indicator-reported-values$"),
    new RegExp("^/projects/[^/]+/key-accomplishments$"),
    new RegExp("^/projects/[^/]+/lake-clarity-basics$"),
    new RegExp("^/projects/[^/]+/local-and-regional-plans$"),
    new RegExp("^/projects/[^/]+/location-as-feature-collection$"),
    new RegExp("^/projects/[^/]+/notes$"),
    new RegExp("^/projects/[^/]+/organizations$"),
    new RegExp("^/projects/[^/]+/related-project-tags$"),
    new RegExp("^/projects/[^/]+/simple-location$"),
    new RegExp("^/projects/[^/]+/threshold-categories$"),
    new RegExp("^/projects/[^/]+/transportation-assessment$"),
    new RegExp("^/projects/[^/]+/transportation-basics$"),
    new RegExp("^/projects/[^/]+/transportation-budget$"),
    new RegExp("^/projects/[^/]+/watersheds$"),
    new RegExp("^/projects/project-location-areas/[^/]+/feature-collection$"),
    new RegExp("^/release-notes/[^/]+$"),
    new RegExp("^/residential-allocations/[^/]+$"),
    new RegExp("^/residential-allocations/[^/]+/pool-history$"),
    new RegExp("^/residential-allocations/by-number/[^/]+$"),
    new RegExp("^/results/lake-clarity-tracker-categories/[^/]+$"),
    new RegExp("^/results/project-spending-by-eip-performance-measure-project-list/[^/]+$"),
    new RegExp("^/results/project-spending-by-eip-performance-measure/[^/]+$"),
    new RegExp("^/road-assessment-observation-periods/[^/]+$"),
    new RegExp("^/road-assessment-observation-periods/[^/]+/assessments$"),
    new RegExp("^/road-classes/[^/]+$"),
    new RegExp("^/road-classes/[^/]+/road-segment-assessments$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/assessments$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/observation-periods$"),
    new RegExp("^/road-registrations/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+/archives$"),
    new RegExp("^/road-registrations/[^/]+/credit-declarations$"),
    new RegExp("^/road-registrations/[^/]+/history$"),
    new RegExp("^/road-registrations/[^/]+/modeled-catchments$"),
    new RegExp("^/road-registrations/[^/]+/modeled-catchments-feature-collection$"),
    new RegExp("^/road-registrations/[^/]+/notifications$"),
    new RegExp("^/road-registrations/[^/]+/plrm-summary-report$"),
    new RegExp("^/road-registrations/[^/]+/review-comments$"),
    new RegExp("^/road-registrations/[^/]+/road-registration-scenario-road-classes$"),
    new RegExp("^/road-registrations/[^/]+/road-segments$"),
    new RegExp("^/road-registrations/[^/]+/supporting-documents$"),
    new RegExp("^/road-registrations/[^/]+/update-rationales$"),
    new RegExp("^/road-registrations/[^/]+/withdraw-rationale$"),
    new RegExp("^/road-registrations/[^/]+/workflow/progress$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/plrm-upload$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/register-credits$"),
    new RegExp("^/road-segment-assessments/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/detail$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/progress$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/assessment-information$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/score$"),
    new RegExp("^/road-segments/[^/]+$"),
    new RegExp("^/road-segments/[^/]+/assessments$"),
    new RegExp("^/road-segments/[^/]+/registrations$"),
    new RegExp("^/shorezone-allocations/[^/]+$"),
    new RegExp("^/shorezone-allocations/by-number/[^/]+$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/bmp-registrations$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/chart-data/[^/]+$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/modeled-catchments$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/people$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/registrations-as-lookup-items$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/road-classes$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/road-registrations$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/road-segments$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/treatment-bmps$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+/water-year-credits$"),
    new RegExp("^/stormwater-jurisdictions/chart-data/[^/]+$"),
    new RegExp("^/tags/[^/]+$"),
    new RegExp("^/tdr-listings/[^/]+$"),
    new RegExp("^/tdr-listings/by-person/[^/]+$"),
    new RegExp("^/threshold-categories/[^/]+$"),
    new RegExp("^/threshold-compliance-measures/[^/]+$"),
    new RegExp("^/threshold-compliance-measures/by-period/[^/]+$"),
    new RegExp("^/threshold-compliance-measures/by-year/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/dashboard/by-period/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/dashboard/by-year/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/[^/]+/can-delete$"),
    new RegExp("^/threshold-evaluation-summary/sections/by-period/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/headers/by-period/[^/]+$"),
    new RegExp("^/threshold-evaluations/[^/]+$"),
    new RegExp("^/threshold-evaluations/[^/]+/documents$"),
    new RegExp("^/threshold-evaluations/[^/]+/images$"),
    new RegExp("^/threshold-evaluations/by-indicator/[^/]+$"),
    new RegExp("^/threshold-evaluations/by-indicator/[^/]+/latest$"),
    new RegExp("^/threshold-evaluations/by-indicator/[^/]+/latest/detail$"),
    new RegExp("^/threshold-evaluations/by-indicator/[^/]+/period/[^/]+$"),
    new RegExp("^/threshold-evaluations/by-period/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/chart-data$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/documents$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/images$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/related-entities$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/reported-values$"),
    new RegExp("^/threshold-indicators/[^/]+$"),
    new RegExp("^/threshold-indicators/[^/]+/related-entities$"),
    new RegExp("^/threshold-indicators/by-threshold-category/[^/]+$"),
    new RegExp("^/threshold-indicators/by-threshold-reporting-category/[^/]+$"),
    new RegExp("^/threshold-indicators/by-threshold-reporting-category/[^/]+/tree$"),
    new RegExp("^/threshold-reporting-categories/[^/]+$"),
    new RegExp("^/threshold-reporting-categories/by-threshold-category/[^/]+$"),
    new RegExp("^/transportation-data-trends/[^/]+$"),
    new RegExp("^/transportation-goals/[^/]+$"),
    new RegExp("^/transportation-objectives/[^/]+$"),
    new RegExp("^/transportation-objectives/[^/]+/expenditure-chart$"),
    new RegExp("^/transportation-objectives/[^/]+/map-markers$"),
    new RegExp("^/transportation-objectives/[^/]+/projects$"),
    new RegExp("^/transportation-objectives/[^/]+/regional/map-markers$"),
    new RegExp("^/transportation-projects/[^/]+$"),
    new RegExp("^/transportation-projects/[^/]+/budgets$"),
    new RegExp("^/transportation-projects/[^/]+/budgets/summary$"),
    new RegExp("^/transportation-questions/[^/]+$"),
    new RegExp("^/transportation-strategies/[^/]+$"),
    new RegExp("^/transportation-strategies/[^/]+/expenditure-chart$"),
    new RegExp("^/transportation-strategies/[^/]+/map-markers$"),
    new RegExp("^/transportation-strategies/[^/]+/projects$"),
    new RegExp("^/transportation-strategies/[^/]+/regional/map-markers$"),
    new RegExp("^/transportation-sub-goals/[^/]+$"),
    new RegExp("^/transportation-sub-goals/by-goal/[^/]+$"),
    new RegExp("^/treatment-bmp-observation-types/[^/]+$"),
    new RegExp("^/treatment-bmp-observation-types/[^/]+/treatment-bmp-types$"),
    new RegExp("^/treatment-bmp-types/[^/]+$"),
    new RegExp("^/treatment-bmp-types/[^/]+/treatment-bmps$"),
    new RegExp("^/treatment-bmp-version-assessment-images/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/observations/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/progress$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/steps/assessment-information$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/steps/photos$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/steps/score$"),
    new RegExp("^/treatment-bmps/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/assessments$"),
    new RegExp("^/treatment-bmps/[^/]+/benchmark-and-thresholds$"),
    new RegExp("^/treatment-bmps/[^/]+/documents$"),
    new RegExp("^/treatment-bmps/[^/]+/images$"),
    new RegExp("^/treatment-bmps/[^/]+/registrations$"),
    new RegExp("^/treatment-bmps/[^/]+/versions$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/assessments$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/benchmark-and-thresholds$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/documents$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/edit-status$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/images$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/edit-status$"),
    new RegExp("^/watersheds/[^/]+$"),
    new RegExp("^/watersheds/[^/]+/boundary$"),
    new RegExp("^/watersheds/[^/]+/expenditure-chart-data$"),
    new RegExp("^/watersheds/[^/]+/project-locations$"),
    new RegExp("^/watersheds/[^/]+/projects$"),
  ],
  'POST': [

  ],
  'PUT': [

  ],
};

const SECURED_REGEX: RegexMap = {
  'DELETE': [
    new RegExp("^/announcements/[^/]+$"),
    new RegExp("^/bmp-compliance-reports/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+/supporting-documents/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/plrm-upload$"),
    new RegExp("^/clarity-documents/[^/]+$"),
    new RegExp("^/climate-resilience-goals/[^/]+$"),
    new RegExp("^/climate-resilience-indicators/[^/]+$"),
    new RegExp("^/climate-resilience-outcomes/[^/]+$"),
    new RegExp("^/climate-resilience-outcomes/[^/]+/iconography$"),
    new RegExp("^/commodity-pools/[^/]+$"),
    new RegExp("^/commodity-pools/[^/]+/disbursements/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/credit-distributions/[^/]+$"),
    new RegExp("^/credit-targets/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/[^/]+$"),
    new RegExp("^/deed-restrictions/[^/]+$"),
    new RegExp("^/document-library/[^/]+$"),
    new RegExp("^/eip-action-priorities/[^/]+$"),
    new RegExp("^/eip-focus-areas/[^/]+$"),
    new RegExp("^/eip-performance-measures/[^/]+$"),
    new RegExp("^/eip-programs/[^/]+$"),
    new RegExp("^/funding-sources/[^/]+$"),
    new RegExp("^/indicators/[^/]+$"),
    new RegExp("^/indicators/[^/]+/notes/[^/]+$"),
    new RegExp("^/indicators/[^/]+/threshold-evaluations/[^/]+/historic-pdf$"),
    new RegExp("^/indicators/[^/]+/threshold-evaluations/[^/]+/map-file$"),
    new RegExp("^/indicators/[^/]+/threshold-overview-image$"),
    new RegExp("^/ipes-scores/[^/]+$"),
    new RegExp("^/lead-agencies/right-of-way-coverages/[^/]+$"),
    new RegExp("^/local-and-regional-plans/[^/]+$"),
    new RegExp("^/local-and-regional-plans/[^/]+/thumbnail$"),
    new RegExp("^/modeled-catchments/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/dashboard$"),
    new RegExp("^/monitoring-programs/[^/]+/documents/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/images/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+/images/[^/]+$"),
    new RegExp("^/mooring-fees/lottery-submission/[^/]+$"),
    new RegExp("^/mooring-lottery-submission-periods/[^/]+$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-and-mooring-information/hoa-documentation$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/upload-documents/[^/]+$"),
    new RegExp("^/mooring-permit-applications/[^/]+/prior-payments/[^/]+$"),
    new RegExp("^/mooring-prior-permit-payments/[^/]+$"),
    new RegExp("^/mooring-prior-permits/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/primary-contact$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/documents/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-moorings/provisional/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+$"),
    new RegExp("^/nrap-findings/documents/[^/]+$"),
    new RegExp("^/nrap-focus-areas/[^/]+$"),
    new RegExp("^/nrap-focus-areas/[^/]+/key-photo$"),
    new RegExp("^/organizations/[^/]+$"),
    new RegExp("^/organizations/[^/]+/logo$"),
    new RegExp("^/parcel-bmp-assessments/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+/banked-development-rights/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+/documents/[^/]+$"),
    new RegExp("^/parcels/[^/]+/images/[^/]+$"),
    new RegExp("^/parcels/[^/]+/land-capability$"),
    new RegExp("^/parcels/[^/]+/notes/[^/]+$"),
    new RegExp("^/project-funding-organizations/[^/]+$"),
    new RegExp("^/project-funding-source-expenditures/[^/]+$"),
    new RegExp("^/project-images/[^/]+$"),
    new RegExp("^/project-implementing-organizations/[^/]+$"),
    new RegExp("^/project-tags/[^/]+$"),
    new RegExp("^/projects/[^/]+$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-detailed/staging$"),
    new RegExp("^/projects/[^/]+/detailed-location/staging$"),
    new RegExp("^/projects/[^/]+/external-links/[^/]+$"),
    new RegExp("^/projects/[^/]+/images/[^/]+$"),
    new RegExp("^/projects/[^/]+/notes/[^/]+$"),
    new RegExp("^/projects/[^/]+/proposal$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed/staging$"),
    new RegExp("^/release-notes/[^/]+$"),
    new RegExp("^/road-assessment-observation-periods/[^/]+$"),
    new RegExp("^/road-classes/[^/]+$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+/supporting-documents/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/plrm-upload/zip$"),
    new RegExp("^/road-segment-assessments/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+/images/[^/]+$"),
    new RegExp("^/road-segments/[^/]+$"),
    new RegExp("^/shorezone-allocations/[^/]+/allocation-letter$"),
    new RegExp("^/support-request-logs/[^/]+$"),
    new RegExp("^/tags/[^/]+$"),
    new RegExp("^/tdr-listings/[^/]+$"),
    new RegExp("^/tdr-transactions/[^/]+$"),
    new RegExp("^/threshold-categories/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/chart-file$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/documents/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/images/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/map-file$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/overview-image$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/threshold-reporting-categories/[^/]+$"),
    new RegExp("^/transportation-data-trends/[^/]+$"),
    new RegExp("^/transportation-goals/[^/]+$"),
    new RegExp("^/transportation-objectives/[^/]+$"),
    new RegExp("^/transportation-questions/[^/]+$"),
    new RegExp("^/transportation-strategies/[^/]+$"),
    new RegExp("^/transportation-sub-goals/[^/]+$"),
    new RegExp("^/treatment-bmp-observation-types/[^/]+$"),
    new RegExp("^/treatment-bmp-types/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessment-images/[^/]+/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/documents/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/images/[^/]+$"),
  ],
  'GET': [
    new RegExp("^/bmp-compliance-reports/[^/]+$"),
    new RegExp("^/commodity-pools/[^/]+$"),
    new RegExp("^/deed-restrictions/[^/]+$"),
    new RegExp("^/document-library/[^/]+$"),
    new RegExp("^/funding-sources/[^/]+/project-expenditures/edit-data$"),
    new RegExp("^/funding-sources/[^/]+/project-funding-requests/edit-data$"),
    new RegExp("^/indicators/[^/]+/can-delete$"),
    new RegExp("^/indicators/[^/]+/subcategories-edit$"),
    new RegExp("^/indicators/[^/]+/threshold-configuration$"),
    new RegExp("^/ipes-scores/[^/]+/access-utilities$"),
    new RegExp("^/ipes-scores/[^/]+/basics$"),
    new RegExp("^/ipes-scores/[^/]+/land-capability-verification$"),
    new RegExp("^/ipes-scores/[^/]+/parcel-information$"),
    new RegExp("^/ipes-scores/[^/]+/score-summary$"),
    new RegExp("^/ipes-scores/[^/]+/soil-hydrology$"),
    new RegExp("^/ipes-scores/[^/]+/workflow-progress$"),
    new RegExp("^/local-and-regional-plans/[^/]+/parcels$"),
    new RegExp("^/monitoring-programs/transit/annual-ridership/[^/]+$"),
    new RegExp("^/monitoring-programs/transit/monthly-ridership/[^/]+$"),
    new RegExp("^/monitoring-users/[^/]+$"),
    new RegExp("^/mooring-fees/lottery-submission/[^/]+$"),
    new RegExp("^/mooring-fees/registration/[^/]+$"),
    new RegExp("^/mooring-lottery-submission-invoices/invoices/[^/]+/payment-detail$"),
    new RegExp("^/mooring-lottery-submission-periods/[^/]+$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/additional-info-template$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/begin-review-template$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/eligible-template$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/not-eligible-template$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/restart-review-template$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/review-detail$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/applicant-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-and-mooring-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-owner-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/progress$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/submit$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/upload-documents$"),
    new RegExp("^/mooring-permit-application-invoices/[^/]+/new-invoice-data$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/edit-data$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/payment-detail$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/reminder-template$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/send-template$"),
    new RegExp("^/mooring-permit-applications/[^/]+/available-prior-payments$"),
    new RegExp("^/mooring-permit-applications/[^/]+/issue-permit-template$"),
    new RegExp("^/mooring-permit-applications/[^/]+/review-detail$"),
    new RegExp("^/mooring-permit-applications/[^/]+/status-change-template$"),
    new RegExp("^/mooring-permit-applications/[^/]+/view-permit$"),
    new RegExp("^/mooring-prior-permits/[^/]+$"),
    new RegExp("^/mooring-registration-period-invoices/[^/]+/new-invoice-data$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/edit-data$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/payment-detail$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/reminder-template$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/send-template$"),
    new RegExp("^/mooring-registration-renewals/[^/]+$"),
    new RegExp("^/mooring-registration-renewals/reminder-messages/[^/]+/preview$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/primary-contact$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review-detail$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/status-change-template$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/can-submit$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/progress$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/applicant-info$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/documents$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/parcel-owner-info$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-moorings$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-parcels$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/submit-review$"),
    new RegExp("^/mooring-tags/[^/]+/report-lost-stolen-void-data$"),
    new RegExp("^/mooring-tags/assign-tags-data/[^/]+$"),
    new RegExp("^/moorings/[^/]+/edit-data$"),
    new RegExp("^/organizations/[^/]+/has-dependents$"),
    new RegExp("^/organizations/[^/]+/transaction-type-commodity-logs$"),
    new RegExp("^/organizations/[^/]+/users$"),
    new RegExp("^/parcel-permits/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+/application-overview$"),
    new RegExp("^/parcel-permits/[^/]+/basics$"),
    new RegExp("^/parcel-permits/[^/]+/deed-restrictions-and-violations$"),
    new RegExp("^/parcel-permits/[^/]+/documents$"),
    new RegExp("^/parcel-permits/[^/]+/exemptions-and-existing-coverage$"),
    new RegExp("^/parcel-permits/[^/]+/existing-inventory$"),
    new RegExp("^/parcel-permits/[^/]+/fees-and-security$"),
    new RegExp("^/parcel-permits/[^/]+/land-capability$"),
    new RegExp("^/parcel-permits/[^/]+/prior-transactions$"),
    new RegExp("^/parcel-permits/[^/]+/proposed-coverage$"),
    new RegExp("^/parcel-permits/[^/]+/proposed-development-rights$"),
    new RegExp("^/parcel-permits/[^/]+/workflow-progress$"),
    new RegExp("^/parcels/[^/]+/audit-logs$"),
    new RegExp("^/parcels/[^/]+/exemptions$"),
    new RegExp("^/parcels/[^/]+/existing-inventory$"),
    new RegExp("^/parcels/[^/]+/land-capability-edit$"),
    new RegExp("^/parcels/[^/]+/parcel-permits$"),
    new RegExp("^/parcels/[^/]+/permissible-uses$"),
    new RegExp("^/parcels/[^/]+/zoning-district$"),
    new RegExp("^/parcels/by-apn/[^/]+/land-capabilities$"),
    new RegExp("^/projects/[^/]+/audit-log$"),
    new RegExp("^/projects/[^/]+/create-workflow/progress$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/basics$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/expected-funding$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-detailed$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-simple$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/notes$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/performance-measures$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/photos$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/project-type$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/stormwater-questionnaire$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/threshold-categories$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/transportation-assessment$"),
    new RegExp("^/projects/[^/]+/system-communications$"),
    new RegExp("^/projects/[^/]+/update-history$"),
    new RegExp("^/projects/[^/]+/update-workflow/current-batch$"),
    new RegExp("^/projects/reminder-messages/[^/]+/preview$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/diff$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/history$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/progress$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/[^/]+/diff$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/basics$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/expected-funding$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/expenditures$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/external-links$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed/staging$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-simple$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/notes$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/performance-measures$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/photos$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/stormwater-questionnaire$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/transportation-budgets$"),
    new RegExp("^/residential-allocations/[^/]+/light-certificate-pdf$"),
    new RegExp("^/road-segment-assessments/new/[^/]+/options$"),
    new RegExp("^/roles/[^/]+/[^/]+$"),
    new RegExp("^/state-lands-permits/by-mooring-registration-submission/[^/]+$"),
    new RegExp("^/stormwater-users/[^/]+$"),
    new RegExp("^/support-request-logs/[^/]+$"),
    new RegExp("^/support-request-logs/areas/[^/]+$"),
    new RegExp("^/tdr-transactions/[^/]+$"),
    new RegExp("^/tdr-transactions/[^/]+/allocation$"),
    new RegExp("^/tdr-transactions/[^/]+/allocation-assignment$"),
    new RegExp("^/tdr-transactions/[^/]+/conversion$"),
    new RegExp("^/tdr-transactions/[^/]+/conversion-with-transfer$"),
    new RegExp("^/tdr-transactions/[^/]+/ecm-retirement$"),
    new RegExp("^/tdr-transactions/[^/]+/land-bank-acquisition$"),
    new RegExp("^/tdr-transactions/[^/]+/land-bank-transfer$"),
    new RegExp("^/tdr-transactions/[^/]+/land-bank-transfers$"),
    new RegExp("^/tdr-transactions/[^/]+/shorezone-allocation$"),
    new RegExp("^/tdr-transactions/[^/]+/transfer$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/preview-evaluation$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments$"),
    new RegExp("^/treatment-bmp-types/[^/]+/archived-bmp-versions$"),
    new RegExp("^/treatment-bmps/[^/]+/benchmark-and-thresholds/edit$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/benchmark-and-thresholds/wizard/observation-types/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/benchmark-and-thresholds/wizard/progress$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/current/edit$"),
    new RegExp("^/user-claims/[^/]+$"),
    new RegExp("^/users/[^/]+$"),
    new RegExp("^/users/[^/]+/api-key$"),
    new RegExp("^/users/[^/]+/notifications$"),
  ],
  'POST': [
    new RegExp("^/accela-cap-records/[^/]+/refresh$"),
    new RegExp("^/bmp-compliance-reports/[^/]+/publish$"),
    new RegExp("^/bmp-registrations/[^/]+/approve$"),
    new RegExp("^/bmp-registrations/[^/]+/approve-update-request$"),
    new RegExp("^/bmp-registrations/[^/]+/approve-withdrawal$"),
    new RegExp("^/bmp-registrations/[^/]+/deny-update-request$"),
    new RegExp("^/bmp-registrations/[^/]+/deny-withdrawal$"),
    new RegExp("^/bmp-registrations/[^/]+/generate-catchment-statistics$"),
    new RegExp("^/bmp-registrations/[^/]+/request-update$"),
    new RegExp("^/bmp-registrations/[^/]+/request-withdrawal$"),
    new RegExp("^/bmp-registrations/[^/]+/return$"),
    new RegExp("^/bmp-registrations/[^/]+/review-comments$"),
    new RegExp("^/bmp-registrations/[^/]+/supporting-documents$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/plrm-upload/file$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/submit$"),
    new RegExp("^/climate-resilience-outcomes/[^/]+/iconography$"),
    new RegExp("^/commodity-pools/[^/]+/disbursements$"),
    new RegExp("^/commodity-pools/[^/]+/transfer$"),
    new RegExp("^/commodity-pools/deallocate/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+/award$"),
    new RegExp("^/credit-declarations/[^/]+/declare$"),
    new RegExp("^/credit-declarations/[^/]+/return$"),
    new RegExp("^/credit-declarations/[^/]+/review-comments$"),
    new RegExp("^/cumulative-accounting/sections/[^/]+/upload-content-file$"),
    new RegExp("^/cumulative-accounting/sections/by-period/[^/]+$"),
    new RegExp("^/impersonation/[^/]+$"),
    new RegExp("^/indicators/[^/]+/activate$"),
    new RegExp("^/indicators/[^/]+/inactivate$"),
    new RegExp("^/indicators/[^/]+/notes$"),
    new RegExp("^/indicators/[^/]+/threshold-evaluations/[^/]+/historic-pdf$"),
    new RegExp("^/indicators/[^/]+/threshold-evaluations/[^/]+/map-file$"),
    new RegExp("^/indicators/[^/]+/threshold-overview-image$"),
    new RegExp("^/ipes-scores/[^/]+/duplicate$"),
    new RegExp("^/ipes-scores/[^/]+/inactivate$"),
    new RegExp("^/ipes-scores/[^/]+/make-official$"),
    new RegExp("^/ipes-scores/[^/]+/record-information-only$"),
    new RegExp("^/ipes-scores/[^/]+/record-official$"),
    new RegExp("^/ipes-scores/[^/]+/transfer$"),
    new RegExp("^/lead-agencies/[^/]+/right-of-way-coverages$"),
    new RegExp("^/local-and-regional-plans/[^/]+/thumbnail$"),
    new RegExp("^/monitoring-programs/[^/]+/documents$"),
    new RegExp("^/monitoring-programs/[^/]+/images$"),
    new RegExp("^/monitoring-programs/[^/]+/images/[^/]+/set-key-photo$"),
    new RegExp("^/monitoring-programs/[^/]+/refresh-external-data$"),
    new RegExp("^/monitoring-sites/[^/]+/images$"),
    new RegExp("^/monitoring-sites/[^/]+/images/[^/]+/set-key-photo$"),
    new RegExp("^/mooring-fees/registration/[^/]+$"),
    new RegExp("^/mooring-lottery-submission-invoices/invoices/[^/]+/record-offline-refund$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/additional-info-required$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/begin-review$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/determine-eligible$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/determine-not-eligible$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/restart-review$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-and-mooring-information/hoa-documentation$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/submit$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/upload-documents$"),
    new RegExp("^/mooring-permit-application-invoices/[^/]+/invoices$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/cancel$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/record-offline-payment$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/record-offline-refund$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/send$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/send-reminder$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+/submit-payment$"),
    new RegExp("^/mooring-permit-applications/[^/]+/accept$"),
    new RegExp("^/mooring-permit-applications/[^/]+/additional-info$"),
    new RegExp("^/mooring-permit-applications/[^/]+/in-review$"),
    new RegExp("^/mooring-permit-applications/[^/]+/incomplete$"),
    new RegExp("^/mooring-permit-applications/[^/]+/issue-permit$"),
    new RegExp("^/mooring-permit-applications/[^/]+/permittee-accepted$"),
    new RegExp("^/mooring-permit-applications/[^/]+/prior-payments$"),
    new RegExp("^/mooring-permit-applications/[^/]+/reject$"),
    new RegExp("^/mooring-permit-applications/[^/]+/rescind$"),
    new RegExp("^/mooring-permit-applications/[^/]+/sign-permit$"),
    new RegExp("^/mooring-permit-applications/[^/]+/withdraw$"),
    new RegExp("^/mooring-prior-permit-payments/[^/]+/split$"),
    new RegExp("^/mooring-registration-period-invoices/[^/]+/invoices$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/cancel$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/record-offline-payment$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/record-offline-refund$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/send$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/send-reminder$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+/submit-payment$"),
    new RegExp("^/mooring-registration-renewals/[^/]+/record-offline-payment$"),
    new RegExp("^/mooring-registration-renewals/[^/]+/submit-payment$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/begin-review$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/confirm$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/create-buoy-permit$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/deactivate$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/pause$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/reject$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/require-buoy-permit-accela$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/restart$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/skip-fast-track$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/withdraw$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/documents$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-moorings/provisional$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/submit$"),
    new RegExp("^/mooring-tags/[^/]+/report-lost-stolen-void$"),
    new RegExp("^/mooring-tags/assign-tags/[^/]+$"),
    new RegExp("^/mooring-tags/mark-as-sent/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+/documents$"),
    new RegExp("^/nrap-focus-areas/[^/]+/key-photo$"),
    new RegExp("^/organizations/[^/]+/logo$"),
    new RegExp("^/parcel-permits/[^/]+/archive$"),
    new RegExp("^/parcel-permits/[^/]+/banked-development-rights$"),
    new RegExp("^/parcel-permits/[^/]+/documents$"),
    new RegExp("^/parcel-permits/[^/]+/land-capability/site-plan$"),
    new RegExp("^/parcel-permits/[^/]+/upload-documents-complete$"),
    new RegExp("^/parcels/[^/]+/deed-restrictions$"),
    new RegExp("^/parcels/[^/]+/images$"),
    new RegExp("^/parcels/[^/]+/notes$"),
    new RegExp("^/projects/[^/]+/change-project-type$"),
    new RegExp("^/projects/[^/]+/create-workflow/approve$"),
    new RegExp("^/projects/[^/]+/create-workflow/override$"),
    new RegExp("^/projects/[^/]+/create-workflow/return$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-detailed/approve-gis-upload$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-detailed/import-gdb$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/photos/upload$"),
    new RegExp("^/projects/[^/]+/create-workflow/submit$"),
    new RegExp("^/projects/[^/]+/create-workflow/withdraw$"),
    new RegExp("^/projects/[^/]+/detailed-location/approve-gis-upload$"),
    new RegExp("^/projects/[^/]+/detailed-location/import-gdb$"),
    new RegExp("^/projects/[^/]+/external-links$"),
    new RegExp("^/projects/[^/]+/images$"),
    new RegExp("^/projects/[^/]+/notes$"),
    new RegExp("^/projects/[^/]+/update-workflow/start$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/approve$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/return$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/[^/]+/revert$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed/approve-gis-upload$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed/import-gdb$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/photos/upload$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/submit$"),
    new RegExp("^/residential-allocations/[^/]+/change-pool$"),
    new RegExp("^/residential-allocations/[^/]+/generate-missing-documents$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/award$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/declare$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/return$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+/review-comments$"),
    new RegExp("^/road-registrations/[^/]+/approve$"),
    new RegExp("^/road-registrations/[^/]+/approve-update-request$"),
    new RegExp("^/road-registrations/[^/]+/approve-withdrawal$"),
    new RegExp("^/road-registrations/[^/]+/deny-update-request$"),
    new RegExp("^/road-registrations/[^/]+/deny-withdrawal$"),
    new RegExp("^/road-registrations/[^/]+/request-update$"),
    new RegExp("^/road-registrations/[^/]+/request-withdrawal$"),
    new RegExp("^/road-registrations/[^/]+/return$"),
    new RegExp("^/road-registrations/[^/]+/review-comments$"),
    new RegExp("^/road-registrations/[^/]+/supporting-documents$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/plrm-upload/file$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/propose-road-segments$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/registration-area$"),
    new RegExp("^/road-registrations/[^/]+/workflow/submit$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+/images$"),
    new RegExp("^/road-segment-assessments/new/[^/]+$"),
    new RegExp("^/shorezone-allocations/[^/]+/allocation-letter$"),
    new RegExp("^/tdr-transactions/[^/]+/change-state$"),
    new RegExp("^/threshold-evaluation-summary/sections/[^/]+/upload-content-file$"),
    new RegExp("^/threshold-evaluation-summary/sections/by-period/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/chart-file$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/documents$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/images$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/map-file$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/overview-image$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/publish$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/publish-public-draft$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments/[^/]+/reactivate$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments/[^/]+/resolve$"),
    new RegExp("^/transportation-questions/[^/]+/archive$"),
    new RegExp("^/transportation-questions/[^/]+/unarchive$"),
    new RegExp("^/treatment-bmp-version-assessment-images/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/documents$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/images$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/new$"),
    new RegExp("^/users/[^/]+/api-key$"),
  ],
  'PUT': [
    new RegExp("^/announcements/[^/]+$"),
    new RegExp("^/bmp-compliance-reports/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/other-strategies$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/parcel-bmps$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/plrm-upload$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/register-bmps$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/registration-area$"),
    new RegExp("^/bmp-registrations/[^/]+/workflow/steps/registration-information$"),
    new RegExp("^/clarity-documents/[^/]+$"),
    new RegExp("^/climate-resilience-goals/[^/]+$"),
    new RegExp("^/climate-resilience-indicators/[^/]+$"),
    new RegExp("^/climate-resilience-outcomes/[^/]+$"),
    new RegExp("^/commodity-pools/[^/]+$"),
    new RegExp("^/commodity-pools/[^/]+/disbursements/[^/]+$"),
    new RegExp("^/credit-declarations/[^/]+$"),
    new RegExp("^/credit-targets/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/sort-headers/[^/]+$"),
    new RegExp("^/cumulative-accounting/sections/sort-subsections/[^/]+$"),
    new RegExp("^/custom-rich-texts/[^/]+$"),
    new RegExp("^/deed-restrictions/[^/]+$"),
    new RegExp("^/document-library/[^/]+$"),
    new RegExp("^/eip-action-priorities/[^/]+$"),
    new RegExp("^/eip-focus-areas/[^/]+$"),
    new RegExp("^/eip-performance-measures/[^/]+$"),
    new RegExp("^/eip-programs/[^/]+$"),
    new RegExp("^/field-definitions/[^/]+$"),
    new RegExp("^/funding-sources/[^/]+$"),
    new RegExp("^/funding-sources/[^/]+/project-expenditures$"),
    new RegExp("^/funding-sources/[^/]+/project-funding-requests$"),
    new RegExp("^/indicators/[^/]+$"),
    new RegExp("^/indicators/[^/]+/associated-programs$"),
    new RegExp("^/indicators/[^/]+/chart-data$"),
    new RegExp("^/indicators/[^/]+/chart-description$"),
    new RegExp("^/indicators/[^/]+/chart-metadata$"),
    new RegExp("^/indicators/[^/]+/chart-sources$"),
    new RegExp("^/indicators/[^/]+/chart-summary$"),
    new RegExp("^/indicators/[^/]+/climate-resilience-additional-charts$"),
    new RegExp("^/indicators/[^/]+/climate-resilience-basics$"),
    new RegExp("^/indicators/[^/]+/climate-resilience-description$"),
    new RegExp("^/indicators/[^/]+/climate-resilience-interpretation$"),
    new RegExp("^/indicators/[^/]+/eip-accounting-period-and-scale$"),
    new RegExp("^/indicators/[^/]+/eip-context$"),
    new RegExp("^/indicators/[^/]+/eip-critical-definitions$"),
    new RegExp("^/indicators/[^/]+/eip-programs$"),
    new RegExp("^/indicators/[^/]+/eip-project-reporting$"),
    new RegExp("^/indicators/[^/]+/monitoring-programs$"),
    new RegExp("^/indicators/[^/]+/notes/[^/]+$"),
    new RegExp("^/indicators/[^/]+/relationships$"),
    new RegExp("^/indicators/[^/]+/subcategories$"),
    new RegExp("^/indicators/[^/]+/threshold-background$"),
    new RegExp("^/indicators/[^/]+/threshold-configuration$"),
    new RegExp("^/indicators/[^/]+/threshold-evaluations/[^/]+/map$"),
    new RegExp("^/indicators/[^/]+/threshold-key-messages$"),
    new RegExp("^/indicators/[^/]+/threshold-overview-image-caption$"),
    new RegExp("^/indicators/[^/]+/threshold-related-entities$"),
    new RegExp("^/indicators/[^/]+/threshold-standards$"),
    new RegExp("^/ipes-scores/[^/]+/access-utilities$"),
    new RegExp("^/ipes-scores/[^/]+/basics$"),
    new RegExp("^/ipes-scores/[^/]+/notes$"),
    new RegExp("^/ipes-scores/[^/]+/parcel-information$"),
    new RegExp("^/ipes-scores/[^/]+/soil-hydrology$"),
    new RegExp("^/lead-agencies/[^/]+/transaction-type-commodities$"),
    new RegExp("^/lead-agencies/right-of-way-coverages/[^/]+$"),
    new RegExp("^/local-and-regional-plans/[^/]+$"),
    new RegExp("^/modeled-catchments/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/dashboard$"),
    new RegExp("^/monitoring-programs/[^/]+/documents/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/images/[^/]+$"),
    new RegExp("^/monitoring-programs/[^/]+/observable-relationships$"),
    new RegExp("^/monitoring-programs/[^/]+/partners$"),
    new RegExp("^/monitoring-programs/[^/]+/site-attributes$"),
    new RegExp("^/monitoring-programs/transit/annual-ridership/[^/]+/route/[^/]+$"),
    new RegExp("^/monitoring-programs/transit/monthly-ridership/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+/images/[^/]+$"),
    new RegExp("^/monitoring-sites/[^/]+/stations/[^/]+$"),
    new RegExp("^/monitoring-users/[^/]+$"),
    new RegExp("^/mooring-fees/lottery-submission/[^/]+$"),
    new RegExp("^/mooring-fees/registration/[^/]+$"),
    new RegExp("^/mooring-lottery-submission-periods/[^/]+$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/checklist/[^/]+$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/applicant-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/deed-restrictions-certification$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-and-mooring-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/parcel-owner-information$"),
    new RegExp("^/mooring-lottery-submissions/[^/]+/workflow/upload-documents/[^/]+$"),
    new RegExp("^/mooring-permit-application-invoices/invoices/[^/]+$"),
    new RegExp("^/mooring-permit-applications/[^/]+/buoy-count$"),
    new RegExp("^/mooring-permit-applications/[^/]+/checklist/[^/]+$"),
    new RegExp("^/mooring-prior-permit-payments/[^/]+/notes$"),
    new RegExp("^/mooring-prior-permits/[^/]+$"),
    new RegExp("^/mooring-registration-period-invoices/invoices/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/assign-reviewer$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/change-primary-contact$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/primary-contact$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/review/checklist/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/applicant-info$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/documents/[^/]+$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/mooring-tag-address$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/notes-for-planner$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/parcel-owner-info$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/parcel-owner-info/skip$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-moorings$"),
    new RegExp("^/mooring-registration-submissions/[^/]+/workflow/steps/select-parcels$"),
    new RegExp("^/moorings/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+$"),
    new RegExp("^/nrap-findings/[^/]+/details$"),
    new RegExp("^/nrap-focus-areas/[^/]+$"),
    new RegExp("^/nrap-focus-areas/[^/]+/monitoring-programs$"),
    new RegExp("^/nrap-focus-areas/[^/]+/state-of-knowledge$"),
    new RegExp("^/organizations/[^/]+$"),
    new RegExp("^/parcel-bmp-assessments/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+/application-overview$"),
    new RegExp("^/parcel-permits/[^/]+/banked-development-rights/[^/]+$"),
    new RegExp("^/parcel-permits/[^/]+/basics$"),
    new RegExp("^/parcel-permits/[^/]+/deed-restrictions-and-violations$"),
    new RegExp("^/parcel-permits/[^/]+/exemptions/prerequisite$"),
    new RegExp("^/parcel-permits/[^/]+/existing-inventory/prerequisite$"),
    new RegExp("^/parcel-permits/[^/]+/fees-and-security$"),
    new RegExp("^/parcel-permits/[^/]+/land-capability/prerequisite$"),
    new RegExp("^/parcel-permits/[^/]+/prior-transactions$"),
    new RegExp("^/parcel-permits/[^/]+/proposed-coverage$"),
    new RegExp("^/parcel-permits/[^/]+/proposed-development-rights$"),
    new RegExp("^/parcels/[^/]+/exemptions$"),
    new RegExp("^/parcels/[^/]+/existing-inventory$"),
    new RegExp("^/parcels/[^/]+/images/[^/]+$"),
    new RegExp("^/parcels/[^/]+/images/[^/]+/set-key-photo$"),
    new RegExp("^/parcels/[^/]+/land-capability$"),
    new RegExp("^/parcels/[^/]+/notes/[^/]+$"),
    new RegExp("^/parcels/[^/]+/overview$"),
    new RegExp("^/project-funding-organizations/[^/]+$"),
    new RegExp("^/project-funding-source-expenditures/[^/]+$"),
    new RegExp("^/project-images/[^/]+$"),
    new RegExp("^/project-implementing-organizations/[^/]+$"),
    new RegExp("^/projects/[^/]+$"),
    new RegExp("^/projects/[^/]+/basics$"),
    new RegExp("^/projects/[^/]+/bounding-box$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/basics$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/expected-funding$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-detailed$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/location-simple$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/notes$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/performance-measures$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/photos$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/project-type$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/stormwater-questionnaire$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/threshold-categories$"),
    new RegExp("^/projects/[^/]+/create-workflow/steps/transportation-assessment$"),
    new RegExp("^/projects/[^/]+/detailed-location$"),
    new RegExp("^/projects/[^/]+/eip-basics$"),
    new RegExp("^/projects/[^/]+/expected-funding$"),
    new RegExp("^/projects/[^/]+/expenditures$"),
    new RegExp("^/projects/[^/]+/external-links$"),
    new RegExp("^/projects/[^/]+/external-links/[^/]+$"),
    new RegExp("^/projects/[^/]+/images$"),
    new RegExp("^/projects/[^/]+/images/[^/]+$"),
    new RegExp("^/projects/[^/]+/images/[^/]+/set-key-photo$"),
    new RegExp("^/projects/[^/]+/indicator-expected-values$"),
    new RegExp("^/projects/[^/]+/indicator-reported-values$"),
    new RegExp("^/projects/[^/]+/lake-clarity-basics$"),
    new RegExp("^/projects/[^/]+/local-and-regional-plans$"),
    new RegExp("^/projects/[^/]+/notes/[^/]+$"),
    new RegExp("^/projects/[^/]+/organizations$"),
    new RegExp("^/projects/[^/]+/simple-location$"),
    new RegExp("^/projects/[^/]+/tags$"),
    new RegExp("^/projects/[^/]+/threshold-categories$"),
    new RegExp("^/projects/[^/]+/transportation-assessment$"),
    new RegExp("^/projects/[^/]+/transportation-basics$"),
    new RegExp("^/projects/[^/]+/transportation-budget$"),
    new RegExp("^/projects/[^/]+/watersheds$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/basics$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/expected-funding$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/expenditures$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/external-links$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-detailed$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/location-simple$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/notes$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/performance-measures$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/photos$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/stormwater-questionnaire$"),
    new RegExp("^/projects/update-workflow/batches/[^/]+/steps/transportation-budgets$"),
    new RegExp("^/release-notes/[^/]+$"),
    new RegExp("^/residential-allocation-pool-history/[^/]+$"),
    new RegExp("^/residential-allocations/[^/]+$"),
    new RegExp("^/road-assessment-observation-periods/[^/]+$"),
    new RegExp("^/road-classes/[^/]+$"),
    new RegExp("^/road-registration-credit-declarations/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/plrm-upload$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/register-road-classes$"),
    new RegExp("^/road-registrations/[^/]+/workflow/steps/registration-information$"),
    new RegExp("^/road-segment-assessments/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/accumulation-zones/[^/]+/images/[^/]+$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/assessment-information$"),
    new RegExp("^/road-segment-assessments/[^/]+/workflow/steps/score$"),
    new RegExp("^/road-segments/[^/]+$"),
    new RegExp("^/shorezone-allocations/[^/]+$"),
    new RegExp("^/stormwater-jurisdictions/[^/]+$"),
    new RegExp("^/stormwater-users/[^/]+$"),
    new RegExp("^/support-request-logs/[^/]+$"),
    new RegExp("^/tags/[^/]+$"),
    new RegExp("^/tdr-listings/[^/]+/basics$"),
    new RegExp("^/tdr-listings/[^/]+/delist$"),
    new RegExp("^/tdr-listings/[^/]+/offer-details$"),
    new RegExp("^/tdr-listings/[^/]+/publish$"),
    new RegExp("^/tdr-listings/[^/]+/relist$"),
    new RegExp("^/tdr-transactions/[^/]+/allocation$"),
    new RegExp("^/tdr-transactions/[^/]+/allocation-assignment$"),
    new RegExp("^/tdr-transactions/[^/]+/conversion$"),
    new RegExp("^/tdr-transactions/[^/]+/conversion-with-transfer$"),
    new RegExp("^/tdr-transactions/[^/]+/ecm-retirement$"),
    new RegExp("^/tdr-transactions/[^/]+/land-bank-acquisition$"),
    new RegExp("^/tdr-transactions/[^/]+/land-bank-transfer$"),
    new RegExp("^/tdr-transactions/[^/]+/shorezone-allocation$"),
    new RegExp("^/tdr-transactions/[^/]+/transfer$"),
    new RegExp("^/threshold-categories/[^/]+$"),
    new RegExp("^/threshold-categories/[^/]+/additional-info$"),
    new RegExp("^/threshold-categories/[^/]+/narrative$"),
    new RegExp("^/threshold-compliance-measures/[^/]+/embedded-url$"),
    new RegExp("^/threshold-compliance-measures/[^/]+/page-content$"),
    new RegExp("^/threshold-evaluation-summary/sections/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/sort-headers/[^/]+$"),
    new RegExp("^/threshold-evaluation-summary/sections/sort-subsections/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/background$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/chart$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/confidence$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/documents/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/evaluation-status$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/images/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/key-messages$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/map$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/public-description$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/rationale$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/references$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/related-entities$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/reported-values$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/review-comments/[^/]+$"),
    new RegExp("^/threshold-indicator-updates/[^/]+/standards$"),
    new RegExp("^/threshold-reporting-categories/[^/]+$"),
    new RegExp("^/threshold-reporting-categories/[^/]+/additional-info$"),
    new RegExp("^/threshold-reporting-categories/[^/]+/narrative$"),
    new RegExp("^/transportation-data-trends/[^/]+$"),
    new RegExp("^/transportation-goals/[^/]+$"),
    new RegExp("^/transportation-objectives/[^/]+$"),
    new RegExp("^/transportation-objectives/[^/]+/description$"),
    new RegExp("^/transportation-projects/[^/]+/budgets$"),
    new RegExp("^/transportation-questions/[^/]+$"),
    new RegExp("^/transportation-strategies/[^/]+$"),
    new RegExp("^/transportation-strategies/[^/]+/description$"),
    new RegExp("^/transportation-strategies/[^/]+/name$"),
    new RegExp("^/transportation-sub-goals/[^/]+$"),
    new RegExp("^/treatment-bmp-observation-types/[^/]+$"),
    new RegExp("^/treatment-bmp-types/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessment-images/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/observations/[^/]+$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/steps/assessment-information$"),
    new RegExp("^/treatment-bmp-version-assessments/[^/]+/workflow/steps/score$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/benchmark-and-thresholds$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/benchmark-and-thresholds/wizard/observation-types/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/documents/[^/]+$"),
    new RegExp("^/treatment-bmps/[^/]+/versions/[^/]+/images/[^/]+$"),
    new RegExp("^/users/[^/]+/activate$"),
    new RegExp("^/users/[^/]+/primary-contact-organizations$"),
    new RegExp("^/users/[^/]+/roles$"),
  ],
};

/**
 * Auth0 httpInterceptor.allowedList generator.
 *
 * This generates route configs that:
 * - For anonymous routes: attach token if user is logged in, allow request if not (allowAnonymous: true)
 * - For secured routes: require token (no allowAnonymous flag)
 *
 * This allows endpoints like /projects to work for both anonymous users (showing public data)
 * and authenticated users (showing additional data based on their identity).
 */
export function buildAuth0AllowedList(apiBaseUrl: string): HttpInterceptorRouteConfig[] {
  const methods: AllowedHttpMethod[] = ['GET','POST','PUT','PATCH','DELETE','OPTIONS','HEAD'];
  const entries: HttpInterceptorRouteConfig[] = [];
  const base = apiBaseUrl.endsWith('/') ? apiBaseUrl.slice(0, -1) : apiBaseUrl;

  // Anonymous routes: attach token if available, allow anonymous access
  for (const method of methods) {
    const exactPaths = ANON_EXACT[method];
    if (exactPaths) {
      for (const path of exactPaths) {
        entries.push({
          uri: base + path,
          httpMethod: method,
          allowAnonymous: true
        });
      }
    }
    const regexPatterns = ANON_REGEX[method];
    if (regexPatterns) {
      for (const rx of regexPatterns) {
        entries.push({
          uriMatcher: (uri: string) => {
            const p = stripBase(apiBaseUrl, uri);
            return p !== null && rx.test(p);
          },
          httpMethod: method,
          allowAnonymous: true
        });
      }
    }
  }

  // Secured routes: require token
  for (const method of methods) {
    const exactPaths = SECURED_EXACT[method];
    if (exactPaths) {
      for (const path of exactPaths) {
        entries.push({
          uri: base + path,
          httpMethod: method
        });
      }
    }
    const regexPatterns = SECURED_REGEX[method];
    if (regexPatterns) {
      for (const rx of regexPatterns) {
        entries.push({
          uriMatcher: (uri: string) => {
            const p = stripBase(apiBaseUrl, uri);
            return p !== null && rx.test(p);
          },
          httpMethod: method
        });
      }
    }
  }

  return entries;
}
